module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-new right-info-block",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "order-instruction-header mb-20"
  }, [_c('i', {
    staticClass: "ion-information-circled header-icon"
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.headings[_vm.step]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "simple-paragraph"
  }, [_c('p', [_vm._v("Niniejszy formularz rejestracyjny pozwoli Ci na zamówienie kompleksowej usługi transportowej, a także dokonanie płatności online w wygodny dla Ciebie sposób.")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "mb-20"
  }, [_vm._v("Wybierz salon podjęcia z dostępnej listy, następnie przejdź dalej uprzednio sprawdzając poprawność dokonanego wyboru na mapie dostępniej poniżej.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wprowadź adres realizacji usługi, który jest krokiem niezbędnym w wyliczeniu trasy przejazdu, a także kosztów transportu.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "mb-20"
  }, [_vm._v("Przed przejściem dalej sprawdź poprawność wprowadzonych danych.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wpisz numer zamówienia i jego wartość, następnie wciśnij przycisk \"Dalej\".")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("2")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 4),
      expression: "step == 4"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wybierz preferowaną datę realizacji spośród dostępnych terminów.")]), _vm._v(" "), _c('p', [_vm._v("W przypadku wyboru innego terminu realizacji, wybierz opcję \"Inny termin\", a następnie wybierz preferowany termin realizacji z dostępnej listy.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 4),
      expression: "step == 4"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "mb-20"
  }, [_vm._v("Wybierz preferowany przedział godzinowy dostawy.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 5),
      expression: "step == 5"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Prosimy o sprawdzenie w podsumowaniu poprawności uzupełnionych danych, a następnie wprowadzenie danych osobowych wraz z numerem telefonu i adresem mailowym na który wysłane zostanie potwierdzenie złożenia zamówienia, a także przyszłe powiadomienia o statusie zlecenia.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 5),
      expression: "step == 5"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("2")]), _vm._v(" "), _c('p', [_vm._v("Jeżeli chcesz zmienić dane do faktury VAT, skorzystaj z opcji \"Zmień dane do faktury\".")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 5),
      expression: "step == 5"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "mb-20"
  }, [_vm._v("Aby dokonać zamówienia usługi transportowej skorzystaj z opcji \"Zamawiam\". W przypadku, gdy Twoje zamówienie zostało już opłacone online lub stacjonarnie w salonie meblowym Agata, skorzystaj z opcji \"Zamawiam (zapłacone)\". Jeśli nie opłaciłeś jeszcze swojego zamówienia, wybierz opcję \"Zamawiam (płacę)\" w celu przejścia do wyboru płatności online.")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Postępuj zgodnie z instrukcjami dostępnymi w niniejszej części formularza. W razie napotkania jakichkolwiek problemów nasi konsultanci są do Twojej dyspozycji pod nr tel.: "), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("(22) 307 68 98")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-20"
  }, [_vm._v("W przypadku większej ilości zamówień dodaj kolejne zamówienie wciskając przycisk "), _c('i', {
    staticClass: "ion-android-add-circle color-blue"
  }), _vm._v(" i postępuj zgodnie z pkt.1. Aby usunąć niechciane zamówienie wciśnij przycisk "), _c('i', {
    staticClass: "ion-android-cancel color-gray"
  }), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60e62e6f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RightBox.vue
// module id = 257
// module chunks = 1